"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _downshift = _interopRequireDefault(require("downshift"));

var _searchModal = _interopRequireDefault(require("./search-modal"));

var _searchResult = _interopRequireDefault(require("./search-result"));

var _debounce = _interopRequireDefault(require("debounce"));

var _viewHelpers = require("@elastic/react-search-ui-views/lib/view-helpers");

var _reactSearchUi = require("@elastic/react-search-ui");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchBox = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchBox, _React$Component);

  var _super = _createSuper(SearchBox);

  function SearchBox(props) {
    var _this;

    _classCallCheck(this, SearchBox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "singleLinksFacet", function (_ref) {
      var className = _ref.className,
          label = _ref.label,
          onRemove = _ref.onRemove,
          onSelect = _ref.onSelect,
          options = _ref.options,
          _ref$values = _ref.values,
          values = _ref$values === void 0 ? [] : _ref$values;
      var value = values[0];
      var siteFilter = options.filter(function (opt) {
        return opt.value === _this.props.site;
      })[0];
      return siteFilter ? /*#__PURE__*/_react.default.createElement("div", {
        className: "py12 border-b border--gray-faint mx6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "toggle-group"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "toggle-container"
      }, /*#__PURE__*/_react.default.createElement("button", {
        key: (0, _viewHelpers.getFilterValueDisplay)(siteFilter.value),
        className: "toggle py3 ".concat(value === siteFilter.value ? 'bg-gray color-white' : ''),
        onClick: function onClick(e) {
          e.preventDefault(); // track click

          if (window && window.analytics) {
            analytics.track(_this.props.segmentTrackEvent, {
              query: _this.props.searchTerm,
              toggle: true,
              site: _this.props.site
            });
          }

          onSelect(siteFilter.value);
        }
      }, (0, _viewHelpers.getFilterValueDisplay)(siteFilter.value))), /*#__PURE__*/_react.default.createElement("div", {
        className: "toggle-container"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick(e) {
          e.preventDefault();
          onRemove(value);
        },
        className: "toggle py3 ".concat(!value ? 'bg-gray color-white' : '')
      }, "All docs")))) : '';
    });

    _this.state = {
      modalOpen: false,
      useModal: !_this.props.disableModal
    };
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.renderModal = _this.renderModal.bind(_assertThisInitialized(_this));
    _this.renderSearchBar = _this.renderSearchBar.bind(_assertThisInitialized(_this));
    _this.singleLinksFacet = _this.singleLinksFacet.bind(_assertThisInitialized(_this));
    _this.checkWidth = (0, _debounce.default)(function () {
      var width = document.body.clientWidth;

      _this.setState({
        useModal: width > 640 && !_this.props.disableModal
      });
    }, 200); // if resultsOnly and overrideSearchTerm, set the search term

    if (_this.props.resultsOnly && _this.props.overrideSearchTerm) {
      props.setSearchTerm(_this.props.overrideSearchTerm);
    }

    return _this;
  }

  _createClass(SearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkWidth();
      window.addEventListener('resize', this.checkWidth);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.checkWidth);
    }
  }, {
    key: "openModal",
    value: function openModal() {
      this.setState({
        modalOpen: true
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.props.reset();
      this.setState({
        modalOpen: false
      });
    }
  }, {
    key: "renderSearchBar",
    value: function renderSearchBar() {
      var _this2 = this;

      var props = this.props;
      return /*#__PURE__*/_react.default.createElement(_downshift.default, {
        id: this.props.inputId,
        inputValue: this.props.searchTerm,
        onChange: function onChange(selection) {
          // track click
          if (window && window.analytics) {
            analytics.track(_this2.props.segmentTrackEvent, {
              query: _this2.props.searchTerm,
              clicked: selection.url.raw
            });
          }

          _this2.props.trackClickThrough(selection.id.raw); // track selection click through


          window.open(selection.url.raw, '_self'); // open selection in current window
        },
        onInputValueChange: function onInputValueChange(newValue) {
          if (props.searchTerm === newValue) return;
          props.setSearchTerm(newValue, {
            debounce: 1500
          }); // track query

          if (window && window.analytics) {
            analytics.track(_this2.props.segmentTrackEvent, {
              query: newValue
            });
          }
        },
        itemToString: function itemToString() {
          return props.searchTerm;
        }
      }, function (downshiftProps) {
        var getInputProps = downshiftProps.getInputProps,
            isOpen = downshiftProps.isOpen,
            getLabelProps = downshiftProps.getLabelProps,
            openMenu = downshiftProps.openMenu;
        return /*#__PURE__*/_react.default.createElement("div", null, !props.resultsOnly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", _extends({
          className: "cursor-pointer"
        }, getLabelProps()), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('absolute flex-parent flex-parent--center-cross flex-parent--center-main', {
            'w60 h60': _this2.state.useModal,
            'w36 h36': !_this2.state.useModal
          })
        }, /*#__PURE__*/_react.default.createElement("svg", {
          className: (0, _classnames.default)('icon color-gray', {
            'w24 h24': _this2.state.useModal,
            'w18 h18': !_this2.state.useModal
          })
        }, /*#__PURE__*/_react.default.createElement("title", null, "Search"), /*#__PURE__*/_react.default.createElement("use", {
          xlinkHref: "#icon-search"
        }))), _this2.props.isLoading && /*#__PURE__*/_react.default.createElement("div", {
          className: "loading loading--s absolute bg-white",
          style: {
            top: _this2.state.useModal ? '21px' : '10px',
            right: '26px',
            zIndex: 5
          }
        })), /*#__PURE__*/_react.default.createElement("input", _extends({
          ref: function ref(input) {
            _this2.docsSeachInput = input;
          },
          placeholder: _this2.props.placeholder,
          className: (0, _classnames.default)('input bg-white', {
            'px60 h60 txt-l': _this2.state.useModal,
            'px36 h36': !_this2.state.useModal
          })
        }, getInputProps({
          onFocus: function onFocus() {
            openMenu();
          }
        })))), (isOpen || props.resultsOnly) && props.searchTerm && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.isLoading && /*#__PURE__*/_react.default.createElement("div", {
          className: "w-full h360 bg-white opacity75 absolute"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "loading mx-auto mt60"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('color-text round mt3 bg-white w-full align-l', {
            'hmax360 scroll-auto scroll-styled absolute shadow-darken25 z4': !props.resultsOnly
          })
        }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactSearchUi.Facet, {
          show: 20,
          field: "site",
          label: "Site",
          view: _this2.singleLinksFacet
        }), props.wasSearched && (_this2.props.results.length ? /*#__PURE__*/_react.default.createElement("ul", null, _this2.props.results.map(function (result, index) {
          return /*#__PURE__*/_react.default.createElement(_searchResult.default, {
            key: index,
            result: result,
            index: index,
            downshiftProps: downshiftProps,
            themeCompact: props.themeCompact
          });
        })) : /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('px12', {
            'py6 txt-s': props.themeCompact,
            'py12 prose': !props.themeCompact
          })
        }, props.emptyResultMessage))))));
      });
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var props = this.props;

      if (!this.state.modalOpen) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_searchModal.default, {
        accessibleTitle: "Search bar",
        onExit: this.closeModal,
        initialFocus: "#".concat(props.inputId, "-input")
      }, /*#__PURE__*/_react.default.createElement("div", null, this.renderSearchBar()));
    }
  }, {
    key: "render",
    value: function render() {
      // hide results until overrideSearchTerm not null
      var hideResultsOnly = this.props.resultsOnly ? this.props.overrideSearchTerm === undefined : false;
      return /*#__PURE__*/_react.default.createElement("div", null, !this.state.useModal ? !hideResultsOnly && /*#__PURE__*/_react.default.createElement("div", {
        className: "w-full"
      }, this.renderSearchBar()) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        className: (0, _classnames.default)('flex-parent flex-parent--center-cross btn--gray color-gray-light btn btn--stroke py3 pl6 pr12 round', {
          'btn--white': this.props.background !== 'light',
          'w-full': !this.props.narrow
        }),
        style: this.props.narrow ? {
          paddingLeft: '12px',
          paddingRight: '12px'
        } : {},
        onClick: this.openModal
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)('', {
          mr6: !this.props.narrow,
          'color-gray': this.props.background === 'light'
        })
      }, /*#__PURE__*/_react.default.createElement("svg", {
        className: "icon w18 h18"
      }, this.props.narrow && /*#__PURE__*/_react.default.createElement("title", null, "Search"), /*#__PURE__*/_react.default.createElement("use", {
        xlinkHref: "#icon-search"
      }))), ' ', !this.props.narrow && /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)('', {
          'color-gray': this.props.background === 'light'
        })
      }, "Search")), this.renderModal()));
    }
  }]);

  return SearchBox;
}(_react.default.Component);

SearchBox.propTypes = {
  searchTerm: _propTypes.default.string,
  trackClickThrough: _propTypes.default.func,
  isLoading: _propTypes.default.bool,
  setSearchTerm: _propTypes.default.func,
  reset: _propTypes.default.func,
  results: _propTypes.default.array,
  placeholder: _propTypes.default.string,
  background: _propTypes.default.oneOf(['light', 'dark']).isRequired,
  inputId: _propTypes.default.string,
  narrow: _propTypes.default.bool,
  disableModal: _propTypes.default.bool,
  site: _propTypes.default.string,
  wasSearched: _propTypes.default.bool,
  resultsOnly: _propTypes.default.bool,
  segmentTrackEvent: _propTypes.default.string,
  overrideSearchTerm: _propTypes.default.string,
  themeCompact: _propTypes.default.bool,
  emptyResultMessage: _propTypes.default.node
};
var _default = SearchBox;
exports.default = _default;